
import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="mt-8 flex flex-col justify-center items-center space-y-4">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-500"></div>
      <p className="text-slate-400 text-lg">AI is crafting your story...</p>
    </div>
  );
};

export default LoadingSpinner;
